import { flatten as _flatten, get as _get } from 'lodash';
import { ImageMetaData, InventoryItem } from 'remarketing-angular-library';

/**
 * Pull image data from an Inventory Item for use in a carousel or other.
 *
 * The logic for extracting the images was pulled from `vehicles-micro-app@1.19.6`
 */
export class InventoryItemImagesModel {
  protected constructor(
    readonly tires: ImageMetaData[],
    readonly damages: ImageMetaData[],
    readonly inspection: ImageMetaData[]
  ) {}

  static fromInventoryItem(item: InventoryItem) {
    const extractImages = (elements: Array<{ images?: ImageMetaData }>): ImageMetaData[] =>
      _flatten(elements.map(e => _get(e, 'images', [])));
    const tiresInspections = _get(item, 'conditionReports[0].inspection.tires', []);
    const damageInspections = _get(item, 'conditionReports[0].inspection.damages', []);
    const inspectionPhotos = _get(item, 'conditionReports[0].inspection.images', []);

    return new InventoryItemImagesModel(
      extractImages(tiresInspections),
      extractImages(damageInspections),
      inspectionPhotos
    );
  }

  all(): ImageMetaData[] {
    return [...this.inspection, ...this.damages, ...this.tires];
  }
}
